import React, { Component } from "react";
import { Row, Col, Form, FormGroup, Label, Input, Button } from 'reactstrap';

class SkillsForm extends Component {
  render() {
    return (
      <div>
        <Form>
          <Row>
            <Col lg="3" sm="6" className="text-center">
              <FormGroup check className="mb-3">
                <Label check>
                  <img className="img-fluid rounded mb-1 d-inline-block"
                       alt=""
                       src="//via.placeholder.com/350x150" />
                  <Input type="checkbox" /> Adaptabilidad
                </Label>
              </FormGroup>
            </Col>
            <Col lg="3" sm="6" className="text-center">
              <FormGroup check className="mb-3">
                <Label check>
                  <img className="img-fluid rounded mb-1 d-inline-block"
                       alt=""
                       src="//via.placeholder.com/350x150" />
                  <Input type="checkbox" /> Comunicación
                </Label>
              </FormGroup>
            </Col>
            <Col lg="3" sm="6" className="text-center">
              <FormGroup check className="mb-3">
                <Label check>
                  <img className="img-fluid rounded mb-1 d-inline-block"
                       alt=""
                       src="//via.placeholder.com/350x150" />
                  <Input type="checkbox" /> Resolución de Problemas
                </Label>
              </FormGroup>
            </Col>
            <Col lg="3" sm="6" className="text-center">
              <FormGroup check className="mb-3">
                <Label check>
                  <img className="img-fluid rounded mb-1 d-inline-block"
                       alt=""
                       src="//via.placeholder.com/350x150" />
                  <Input type="checkbox" /> Creatividad
                </Label>
              </FormGroup>
            </Col>
            <Col lg="3" sm="6" className="text-center">
              <FormGroup check className="mb-3">
                <Label check>
                  <img className="img-fluid rounded mb-1 d-inline-block"
                       alt=""
                       src="//via.placeholder.com/350x150" />
                  <Input type="checkbox" /> Relaciones Interpersonales
                </Label>
              </FormGroup>
            </Col>
            <Col lg="3" sm="6" className="text-center">
              <FormGroup check className="mb-3">
                <Label check>
                  <img className="img-fluid rounded mb-1 d-inline-block"
                       alt=""
                       src="//via.placeholder.com/350x150" />
                  <Input type="checkbox" /> Trabajo en equipo
                </Label>
              </FormGroup>
            </Col>
            <Col lg="3" sm="6" className="text-center">
              <FormGroup check className="mb-3">
                <Label check>
                  <img className="img-fluid rounded mb-1 d-inline-block"
                       alt=""
                       src="//via.placeholder.com/350x150" />
                  <Input type="checkbox" /> Deseo de aprender
                </Label>
              </FormGroup>
            </Col>
            <Col lg="3" sm="6" className="text-center">
              <FormGroup check className="mb-3">
                <Label check>
                  <img className="img-fluid rounded mb-1 d-inline-block"
                       alt=""
                       src="//via.placeholder.com/350x150" />
                  <Input type="checkbox" /> Otra Habilidad
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="12" className="text-end">
              <Button color="primary" className="my-4">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

export default SkillsForm;
